var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTruckIcon = function SvgTruckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 10.667V4.133c0-.746 0-1.12-.145-1.405a1.333 1.333 0 0 0-.583-.583C9.653 2 9.28 2 8.533 2H3.466c-.746 0-1.12 0-1.405.145-.25.128-.455.332-.583.583-.145.285-.145.659-.145 1.405v4.4c0 .747 0 1.12.145 1.406.128.25.332.454.583.582.285.146.659.146 1.405.146h7.2Zm0 0H13.6c.373 0 .56 0 .702-.073a.666.666 0 0 0 .292-.291c.072-.143.072-.33.072-.703V7.775c0-.163 0-.244-.018-.321a.664.664 0 0 0-.08-.193c-.041-.067-.099-.125-.214-.24l-1.375-1.375a1.425 1.425 0 0 0-.24-.214.665.665 0 0 0-.193-.08c-.077-.019-.158-.019-.321-.019h-1.559m-4.666 7a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0Zm7.333 0a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgTruckIcon;